import { getDefinition, MediaType } from '../../../general/components/FullscreenPreview/model';
import { Asset } from '../../api';

export type PreviewShape = {
  inProgress: Partial<Record<Asset['id'], true>>;
  modal: {
    assetId: Asset['id'] | undefined;
    open: boolean;
  };
};

export const isCustomPreviewAllowed = (asset: Asset): boolean => {
  const isForbidden: Partial<Record<MediaType, true>> = {
    [MediaType.Audio]: true,
    [MediaType.IFrame]: true,
    [MediaType.Compressed]: true,
    [MediaType.Text]: true,
    [MediaType.Docx]: true,
  };

  const assetDefinition = getDefinition(asset.name);

  return !isForbidden[assetDefinition.mt];
};

export const ALLOWED_PREVIEW_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'mp4', 'webm', 'mov'];
